import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { useIsPaywallCountdownEnabled } from "@circle-react/hooks/useIsPaywallCountdownEnabled";
import { CountdownComponent } from "./CountdownComponent";
import { useCountdown } from "./hooks/useCountdown";
import { useCountdownPreview } from "./hooks/useCountdownPreview";

export const Countdown = () => {
  const { paywallCustomization, checkoutPreviewContext } =
    usePaywallCheckoutContext();

  const { enabled: isCountdownEnabled } =
    paywallCustomization?.countdown_properties || {
      enabled: false,
    };

  const isCommunityPaywallCountdownEnabled = useIsPaywallCountdownEnabled();

  if (!isCommunityPaywallCountdownEnabled) {
    return null;
  }

  if (!paywallCustomization?.countdown_properties) {
    return null;
  }

  if (!isCountdownEnabled) {
    return null;
  }

  const countdownProperties = paywallCustomization.countdown_properties;
  if (checkoutPreviewContext) {
    return (
      <CountdownComponent
        countdownProperties={countdownProperties}
        useHook={useCountdownPreview}
      />
    );
  }

  return (
    <CountdownComponent
      countdownProperties={countdownProperties}
      useHook={useCountdown}
    />
  );
};
